import fionaPic from "@/public/images/artists/fiona.png";
import { Artist } from "@/types/types";

export const fiona = {
  id: "183",
  name: "Fiona",
  image: fionaPic,
  description: `Fiona is a whisper model designed for backing vocals or spoken word with rhythmic elements. Her output strips away melodic structure, creating almost atonal samples that emphasize rhythm and texture. Perfect for adding depth and intrigue as a whisper double for your lead vocal.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffiona-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed"],
      secondary: ["Experimental", "Whisper", "Atonal", "Backing vocals"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 60,
        high: 68,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
